<div
	id="kt_create_loading_files"
	class="bg-body pay-upload-files-z-index"
	data-kt-drawer="true"
	data-kt-drawer-name="create_loading_files"
	data-kt-drawer-activate="true"
	data-kt-drawer-overlay="true"
	data-kt-drawer-width="{default:'100%', 'lg': '900px'}"
	data-kt-drawer-direction="end"
	data-kt-drawer-toggle="#kt_create_loading_files_toggle"
	data-kt-drawer-close="#kt_create_loading_files_close"
>
	<div class="card shadow-none rounded-0 w-100">
		<div class="card-header" id="kt_create_loading_files_header">
			<div class="d-flex felx-row justify-content-between align-items-center">
				<div class="d-flex flex-column">
					<h3 class="card-title fw-bolder text-gray-900" translate>create_loading_file_drawer_title</h3>
					<span class="text-muted fs-7 fw-semibold" translate>create_loading_file_drawer_description</span>
				</div>
				<div>
					<button type="button" (click)="onFileSelectClick()" class="hover-elevate-up btn btn-primary d-flex justify-content-between round py-4">
						<app-keenicon name="cloud-add" class="fs-3 text-white"></app-keenicon>
						<span class="text-white font-size-sm ms-2" translate>create_loading_file_drawer_upload</span>
					</button>
					<input type="file" id="fileInput" multiple style="display: none" (change)="onFilesSelected($event)" />
				</div>
			</div>
		</div>
		<div class="card-body position-relative" id="kt_create_loading_files_body">
			<div
				id="kt_create_loading_files_scroll"
				class="position-relative scroll-y me-n5 pe-5"
				data-kt-scroll="true"
				data-kt-scroll-height="auto"
				data-kt-scroll-wrappers="#kt_create_loading_files_body"
				data-kt-scroll-dependencies="#kt_create_loading_files_header, #kt_create_loading_files_footer"
				data-kt-scroll-offset="0px"
			>
				<div>
					@if (uploadProgress$ | async) {
						<div class="bg-light w-100 rounded" style="height: 40px">
							<div class="bg-primary h-100 rounded" [style.width.%]="uploadProgress$ | async">
								<span class="d-flex px-5 py-3 text-whit fw-bold">{{ uploadProgress$ | async }}%</span>
							</div>
						</div>
					}
				</div>
			</div>
		</div>
		<div class="card-footer py-5 d-flex justify-content-between align-items-center" id="kt_create_loading_files_footer">
			<button id="kt_create_loading_files_close" type="button" class="hover-elevate-up btn btn-light d-flex justify-content-between round py-4" (click)="onClose()">
				<app-keenicon name="to-left" class="fs-3 text-muted me-3"></app-keenicon>
				<span class="text-muted font-size-sm" translate>drawer_back</span>
			</button>
		</div>
	</div>
</div>
